import React, {lazy, Suspense} from 'react';
import PrequalRoutes from './PrequalRoutes';
import PrequalRoutesWCButton from './PrequalRoutesWC';
import {openWindow} from '../utils/windowUtils';

const MaintenancePage = lazy(() => import('../pages/MaintenancePage/MaintenancePage'));
const renderLoader = () => <p>Loading</p>;
function PrequalRouteSwitch({appConfig, customerData, dispatch, maintenanceStatus, maintenanceEndTime}) {
  if (!customerData.isDealerHostApplication.value) {
    return maintenanceStatus ? (
      <main>
        <Suspense fallback={renderLoader()}>
          <MaintenancePage
            maintenanceEndTime={maintenanceEndTime}
            dispatch={dispatch}
            customerData={customerData}
            appConfig={appConfig}
            openWindow={openWindow}
          />
        </Suspense>
      </main>
    ) : (
      <PrequalRoutes customerData={customerData} dispatch={dispatch} appConfig={appConfig} />
    );
  }
  return (
    <PrequalRoutesWCButton customerData={customerData} dispatch={dispatch} appConfig={appConfig} maintenanceStatus={maintenanceStatus} />
  );
}

export default PrequalRouteSwitch;
